import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from 'vue';
  
export default /*#__PURE__*/_defineComponent({
  __name: 'Tab',
  props: [ 'active', 'icon' ],
  setup(__props, { expose: __expose }) {
  __expose();

  const props = __props;

const __returned__ = { props, ref, onMounted }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})